import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Client } from '../models/customer.model';
import { map } from 'rxjs/operators';
import { Machine, MachineInspection } from '../models';

@Injectable({ providedIn: 'root' })
export class MachineModuleService {
  constructor(protected apiService: ApiService) {}

  getCustomers(pageNumber = 1, pageSize = 50, search = ''): Observable<Client[]> {
    const params: any = {
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
      search: search
    };

    return this.apiService
      .get('/customers', null, params)
      .pipe(map((customers: Client[]) => customers.map((c) => Object.assign(new Client(), c))));
  }

  getCustomer(clientNumber: string): Observable<Client> {
    return this.apiService.get(`/customers/${clientNumber}`).pipe(map((customer: Client) => Object.assign(new Client(), customer)));
  }

  createCustomer(customer: Client): Observable<Client> {
    return this.apiService.post('/customers', customer).pipe(map((result: Client) => Object.assign(new Client(), result)));
  }

  updateCustomer(clientNumber: string, customer: Client): Observable<Client> {
    return this.apiService.put(`/customers/${clientNumber}`, customer).pipe(map((result: Client) => Object.assign(new Client(), result)));
  }

  getCustomerMachines(clientNumber: string, pageNumber = 1, pageSize = 50, search = ''): Observable<Machine[]> {
    const params: any = {
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
      search: search
    };

    return this.apiService
      .get(`/customers/${clientNumber}/machines`, null, params)
      .pipe(map((customers: Machine[]) => customers.map((c) => Object.assign(new Machine(), c))));
  }

  getMachines(pageNumber = 1, pageSize = 50, search = ''): Observable<Machine[]> {
    const params: any = {
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
      search: search
    };

    return this.apiService
      .get('/machines', null, params)
      .pipe(map((machines: Machine[]) => machines.map((m) => Object.assign(new Machine(), m))));
  }

  getMachine(serialNumber: string): Observable<Machine> {
    return this.apiService.get(`/machines/${serialNumber}`).pipe(map((machine: Machine) => Object.assign(new Machine(), machine)));
  }

  getMachineInspections(serial: string): Observable<MachineInspection[]> {
    return this.apiService
      .get(`/machines/${serial}/inspections`)
      .pipe(map((inspections: MachineInspection[]) => inspections.map((m) => Object.assign(new MachineInspection(), m))));
  }

  getCustomerInspections(clientNumber: string): Observable<MachineInspection[]> {
    return this.apiService
      .get(`/customers/${clientNumber}/inspections`)
      .pipe(map((inspections: MachineInspection[]) => inspections.map((m) => Object.assign(new MachineInspection(), m))));
  }

  createMachine(clientNumber: string, machine: Machine): Observable<Machine> {
    return this.apiService
      .post(`/customers/${clientNumber}/machines`, machine)
      .pipe(map((result: Machine) => Object.assign(new Machine(), result)));
  }

  updateMachine(serialNumber: string, machine: Machine): Observable<Machine> {
    return this.apiService.put(`/machines/${serialNumber}`, machine).pipe(map((result: Machine) => Object.assign(new Machine(), result)));
  }
}
